import * as tour from './tour';
import * as utils from './common';

(function($) {

	tour.init();

	if (document.querySelectorAll('#stats .figures-grid').length) {
		const statsScrollObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.target.classList.contains('scrolled') && entry.isIntersecting) {
					entry.target.classList.add('scrolled');
					jQuery('.figure').each(function() {
						utils.animationCount(jQuery(this), 0, jQuery(this).data('number'));
					});
				}
			});
		}, {
			threshold: 0.25
		});
		statsScrollObserver.observe(document.querySelectorAll('#stats .figures-grid')[0]);
	}

})(jQuery);
